var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{staticClass:"text-center"},[_c('div',{staticClass:"title-behind",domProps:{"textContent":_vm._s(_vm.title)}}),_c('h3',{domProps:{"textContent":_vm._s(_vm.subtitle)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }